// src/components/portfolio/add-asset/utils/icons/CurrencyIcon.js
import React from 'react';

const CurrencyIcon = ({ symbol }) => {
  return (
    <div className="w-8 h-8 rounded-full flex items-center justify-center bg-gray-100 dark:bg-gray-700">
      <img
        src={`/images/currencys/${symbol.toLowerCase()}.png`}
        alt={symbol}
        className="w-6 h-6"
        onError={(e) => {
          e.target.onerror = null;
          e.target.style.display = 'none';
          e.target.parentElement.innerHTML = `<span class="text-sm font-medium">${symbol.slice(0, 2)}</span>`;
        }}
      />
    </div>
  );
};

export default CurrencyIcon;